"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerSearchServiceV2Proxy = void 0;
const INSTANCE_ID_SEPARATOR = '@';
class DealerSearchServiceV2Proxy {
    constructor(logger, delegate) {
        this.logger = logger;
        this.delegate = delegate;
        this.listeners = new Map();
    }
    parseConsumerId(consumerId) {
        return consumerId === null || consumerId === void 0 ? void 0 : consumerId.split(INSTANCE_ID_SEPARATOR)[0];
    }
    getFilter(consumerId) {
        this.logger.warn(`Dealer Search Service V2 is deprecated, use V3 instead.`);
        consumerId = this.parseConsumerId(consumerId);
        return this.delegate.getFilter(consumerId);
    }
    getSelectedDealer(consumerId) {
        var _a;
        this.logger.warn(`Dealer Search Service V2 is deprecated, use V3 instead.`);
        consumerId = this.parseConsumerId(consumerId);
        return ((_a = this.transformDealerFromV3(this.delegate.getSelectedDealer(consumerId))) !== null && _a !== void 0 ? _a : this.sharedDealerData);
    }
    getListeners(consumerId) {
        var _a;
        this.logger.warn(`Dealer Search Service V2 is deprecated, use V3 instead.`);
        consumerId = this.parseConsumerId(consumerId);
        return (_a = this.listeners.get(consumerId)) !== null && _a !== void 0 ? _a : new Set();
    }
    registerOnSelectedDealerChange(consumerId, callback) {
        this.logger.warn(`Dealer Search Service V2 is deprecated, use V3 instead.`);
        consumerId = this.parseConsumerId(consumerId);
        this.listeners.set(consumerId, this.getListeners(consumerId).add(callback));
        const callbackV3 = (data) => {
            callback(this.transformDealerFromV3(data));
        };
        const unsubscribeV3 = this.delegate.registerOnSelectedDealerChange(consumerId, callbackV3);
        const unsubscribe = () => {
            unsubscribeV3();
            this.getListeners(consumerId).delete(callback);
        };
        return unsubscribe;
    }
    setFilter(consumerId, filter) {
        this.logger.warn(`Dealer Search Service V2 is deprecated, use V3 instead.`);
        consumerId = this.parseConsumerId(consumerId);
        this.delegate.setFilter(consumerId, filter);
    }
    setSelectedDealer(consumerId, data) {
        this.logger.warn(`Dealer Search Service V2 is deprecated, use V3 instead.`);
        consumerId = this.parseConsumerId(consumerId);
        if (this.getSelectedDealer(consumerId) !== data) {
            this.delegate.setSelectedDealer(consumerId, this.transformDealerToV3(data));
        }
    }
    transformDealerToV3(dealerData) {
        var _a;
        if (dealerData) {
            const dealerId = {
                id: dealerData.id,
                brand: 'V',
                market: (_a = dealerData.address.countryCode) !== null && _a !== void 0 ? _a : '',
            };
            return Object.assign(Object.assign({}, dealerData), { id: dealerId });
        }
        return null;
    }
    transformDealerFromV3(dealerDataV3) {
        if (dealerDataV3) {
            return Object.assign(Object.assign({}, dealerDataV3), { id: dealerDataV3.id.id });
        }
        return null;
    }
}
exports.DealerSearchServiceV2Proxy = DealerSearchServiceV2Proxy;
//# sourceMappingURL=index.js.map